/* ===== Anadita Luxe — lightweight email capture popup ===== */
(function () {
  'use strict';
  var popup = document.querySelector('[data-email-popup]');
  if (!popup) return;

  // Manual close (X / overlay / Escape): only suppressed for the rest of THIS
  // browsing session (sessionStorage) — reappears on the next visit/new tab,
  // but won't re-nag as someone clicks between pages right now.
  var SESSION_KEY = 'anadita_email_popup_session_dismissed';
  // Successful signup: suppressed for a year — they already have the code,
  // no reason to ask again.
  var SIGNUP_KEY = 'anadita_email_popup_signed_up';
  var SHOW_AFTER_MS = 4000;
  var SHOW_AFTER_SCROLL_PCT = 0.25;

  function sessionDismissed() {
    try { return sessionStorage.getItem(SESSION_KEY) === '1'; } catch (e) { return false; }
  }
  function alreadySignedUp() {
    try {
      var v = localStorage.getItem(SIGNUP_KEY);
      if (!v) return false;
      return Date.now() < parseInt(v, 10);
    } catch (e) { return false; }
  }
  function suppressed() { return sessionDismissed() || alreadySignedUp(); }

  function open() {
    if (suppressed() || popup.classList.contains('is-open')) return;
    popup.removeAttribute('hidden');
    popup.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () { popup.classList.add('is-open'); });
  }
  function close() {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    setTimeout(function () { popup.setAttribute('hidden', ''); }, 250);
  }
  function dismissForSession() {
    try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) {}
    close();
  }

  popup.addEventListener('click', function (e) {
    if (e.target.closest('[data-email-popup-close]')) { e.preventDefault(); dismissForSession(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') dismissForSession(); });

  // On the reload after a successful signup, show the success panel (it has the
  // discount code) immediately, then don't ask this visitor again for a year.
  var form = popup.querySelector('.newsletter-form');
  if (form && popup.querySelector('.form__success')) {
    open();
    try { localStorage.setItem(SIGNUP_KEY, String(Date.now() + 365 * 86400000)); } catch (e) {}
  }

  if (suppressed()) return;

  var shown = false;
  function maybeShow() {
    if (shown || suppressed()) return;
    shown = true;
    open();
  }

  setTimeout(maybeShow, SHOW_AFTER_MS);

  window.addEventListener('scroll', function () {
    if (shown) return;
    var scrolled = window.scrollY / (document.documentElement.scrollHeight - window.innerHeight || 1);
    if (scrolled >= SHOW_AFTER_SCROLL_PCT) maybeShow();
  }, { passive: true });
})();
